"use strict";
/**
 * @class BadgeLabel
 * @description label for inside the badges
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BadgeLabel = function (_a) {
    var text = _a.text;
    return (React.createElement("text", { x: "50%", y: "50%", dy: "0.67ex", className: "oui__badge__label" }, text));
};
exports.default = BadgeLabel;
//# sourceMappingURL=BadgeLabel.js.map